"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComposeSurfaceActionsOption_1 = require("owa-surface-actions-option/lib/ComposeSurfaceActionsOption");
var ReadSurfaceActionsOption_1 = require("owa-surface-actions-option/lib/ReadSurfaceActionsOption");
var surfaceActionsSubCategory = {
    key: 'surfaceActions',
    titleStringKey: 'optionSubcategory_surfaceActions',
    options: [ReadSurfaceActionsOption_1.default, ComposeSurfaceActionsOption_1.default],
};
exports.default = surfaceActionsSubCategory;
//# sourceMappingURL=surfaceActionsSubcategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/data/surfaceActionsSubcategory.js
// module id = 5236
// module chunks = 2